import { Rating } from '@mui/material'
import { useEffect, useState } from 'react'
import { BiRefresh, BiCommentDetail } from 'react-icons/bi'
import { getStatsOverview } from '../../api'
import { ForumMessages, Heading, Loading, Section } from '../../components'
import { useAppState } from '../../hooks'
import { TCypher, THelp } from '../../types'
import './overview.scss'

export const Overview = () => {
    const [loading, setLoading] = useState(false)
    const [cyphers, setCyphers] = useState<TCypher[]>([])
    const [visibleComments, setVisibleComments] = useState<{ [key: number]: boolean }>({})
    const { state } = useAppState()
    


    useEffect(() => {
        refresh()
    }, [])

    const refresh = () => {
        setLoading(true)
        getStatsOverview({ token: state!!.token!! }).then(res => {
            if (res.cyphers) {
                setCyphers(res.cyphers)
            }
        }).finally(() => setLoading(false))
    }

    const toggleComments = (cypherId: number) => {
        setVisibleComments(prev => ({
            ...prev,
            [cypherId]: !prev[cypherId] 
        }))
    }

    const helpsUsage = (helps: THelp[]) => {
        return (
            <div className='overview__cypher__helps__teams'> {helps.map(h => <div>{`${h.order}${h.type}: ${h.teams} týmů`}</div >)}</div >
        )
    }

    if (loading) {
        return <Loading />
    }

    return (
        <Section>
            <Heading headline='Přehled hry' weight={1} />
            <div className='refresh'>
                <BiRefresh onClick={refresh} size={25} />
            </div>
            <div className='overview'>
                {cyphers.map(c =>
                    <div className='overview__cypher'>
                        <Heading headline={`${c.Id}-${c.name}`} weight={3} />
                        <div className='overview__cypher__rating'>
                            <Rating
                                name="read-only"
                                value={c.stars}
                                className='rating__stars'
                                readOnly
                                precision={0.1}
                            />
                            {c.votes!! > 0 ? <div>{`(${c.votes} hlasů)`}</div> : ''}
                            
                        </div>
                        {c.comments?.length!! > 0
                            ?
                            <div className='overview__cypher__comments'>
                                <div
                                    className='overview__cypher__comments__href'
                                    onClick={() => toggleComments(c.Id)}
                                >
                                    <BiCommentDetail size={25} /> {c.comments?.length!!}
                                </div>
                                {visibleComments[c.Id] && (
                                    <div className='overview__cypher__comments__list'>
                                        <ForumMessages messages={c.comments} />
                                    </div>
                                )}
                            </div>
                            : ''}
                        <div className='overview__cypher__teams'>
                            Počet týmů na šifře: {c.teams }
                        </div>
                        {c.helps?.length!! > 0
                            ?   <div className='overview__cypher__helps'>
                                Využité nápovědy: {helpsUsage(c.helps!)}
                                </div>
                            : ''}
                    </div>
                )}
            </div>
        </Section>
    )
}